import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

//This is my case
const routes: Routes = [
  {
    path: '',
    redirectTo: 'land',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
